'use client';

import { useRouter } from 'next/navigation';
import { ArrowLeft } from 'lucide-react';

export default function BackButton() {
  const router = useRouter();

  return (
    <button
      onClick={() => router.push('/')}
      className="flex items-center gap-2 text-gray-600 hover:text-gray-900 font-semibold transition-colors"
    >
      <ArrowLeft size={20} />
      <span className="hidden sm:inline">Retour</span>
    </button>
  );
}
